import { includes } from 'lodash';
/**
 * Check if a tasks feature is enabled or not
 *
 * @param {ReduxState} state
 * @param {string} channelId
 * @returns {boolean}
 */
export var isExternalShareFeatureEnabled = function (state, channelId) {
    var externalShareFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'externalShare'; });
    return (externalShareFeature &&
        externalShareFeature.configuration !== 'deactivated' &&
        (externalShareFeature.configuration === 'tube' ||
            includes(externalShareFeature.activatedIn, state.auth.tube.id) ||
            includes(externalShareFeature.activatedIn, channelId)));
};
/**
 * Check if a tasks feature is enabled or not
 *
 * @param {ReduxState} state
 * @param {string} channelId
 * @returns {boolean}
 */
export var isTasksFeatureEnabled = function (state, channelId) {
    var tasksFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'tasks'; });
    return (tasksFeature &&
        tasksFeature.configuration !== 'deactivated' &&
        (tasksFeature.configuration === 'tube' ||
            includes(tasksFeature.activatedIn, state.auth.tube.id) ||
            includes(tasksFeature.activatedIn, channelId)));
};
/**
 * Check if a tasks chat feature is enabled or not
 *
 * @param {ReduxState} state
 * @param {string} channelId
 * @returns {boolean}
 */
export var isChatFeatureEnabled = function (state, channelId) {
    var chatFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'tasks-chat'; });
    return (chatFeature &&
        chatFeature.configuration !== 'deactivated' &&
        (chatFeature.configuration === 'tube' ||
            includes(chatFeature.activatedIn, state.auth.tube.id) ||
            includes(chatFeature.activatedIn, channelId)));
};
/**
 * Note: Notifications feature is only checked to be enabbled on a tube. Not in a chanel
 *
 * @param {ReduxState} state
 * @returns {boolean}
 */
export var isNotificationsFeatureEnabled = function (state) {
    var notificationsFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'notifications'; });
    return notificationsFeature && notificationsFeature.configuration !== 'deactivated';
};
/**
 * Note: User profile feature is only checked to be enabbled on a tube. Not in a chanel
 *
 * @param {ReduxState} state
 * @returns {boolean}
 */
export var isUserProfileFeatureEnabled = function (state) {
    var userProfileFeature = state.auth.organization.featureFlags.find(function (f) { return f.featureId === 'userProfile'; });
    return userProfileFeature && userProfileFeature.configuration !== 'deactivated';
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/featureFlagChecks.ts
// module id = 424
// module chunks = 81